<template>
  <div>
    <div>
      <div v-if="loaded && transactions.length === 0">
        <div class="alert alert-primary" role="alert">تراکنشی یافت نشد.</div>
      </div>
    </div>

    <div v-if="loaded && transactions.length" class="card card-custom gutter-b">
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-head-custom table-head-bg table-borderless table-vertical-center"
          >
            <thead>
              <tr>
                <th>بابت</th>
                <th>مبلغ (ریال)</th>
                <th>توضیحات</th>
                <th>تاریخ</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="transaction in transactions" :key="transaction.id">
                <td class="text-nowrap">
                  <router-link
                    v-show="transaction.relation_type === 3"
                    class="text-primary"
                    :to="{
                      name: 'receipts-lives-show',
                      params: { id: transaction.relation_id }
                    }"
                  >
                    {{ transactionRelationTypes[transaction.relation_type] }}
                  </router-link>
                  <router-link
                    v-show="transaction.relation_type === 4"
                    class="text-primary"
                    :to="{
                      name: 'receipts-storage-show',
                      params: { id: transaction.relation_id }
                    }"
                  >
                    {{ transactionRelationTypes[transaction.relation_type] }}
                  </router-link>
                  <span
                    v-show="
                      transaction.relation_type !== 3 &&
                        transaction.relation_type !== 4
                    "
                  >
                    {{ transactionRelationTypes[transaction.relation_type] }}
                  </span>
                </td>
                <td dir="ltr" :class="{ 'text-danger': transaction.value < 0 }">
                  {{ numberFormat(transaction.value) }}
                </td>
                <td class="text-nowrap">{{ transaction.description }}</td>
                <td dir="ltr" class="text-nowrap">
                  {{ formatDate(transaction.created_at) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="overflow-auto mt-5" v-if="transactionsPagination.lastPage > 1">
      <b-pagination
        v-model="transactionsPagination.currentPage"
        :total-rows="transactionsPagination.total"
        :per-page="transactionsPagination.perPage"
        aria-controls="my-table"
        @input="updateTransactions()"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import { FETCH_TRANSACTIONS } from "@/core/services/store/transactions.module";
import { mapGetters } from "vuex";

export default {
  name: "transactions",
  data() {
    return {
      loaded: false
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "تراکنش‌ها" }]);
    this.$store.dispatch(SET_ACTIONS, {});

    this.updateTransactions();
  },
  computed: {
    ...mapGetters([
      "transactions",
      "transactionsPagination",
      "transactionRelationTypes"
    ])
  },
  methods: {
    updateTransactions() {
      this.loaded = false;

      this.$store
        .dispatch(FETCH_TRANSACTIONS)
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    }
  }
};
</script>
